import { api } from "constants/RotasAPI";
import useFetch from "hooks/useFetch";
import { toast } from "react-hot-toast";

export const useGetStatusAtivacaoGroupPay = (codigoSuporte: string) => {
  const onError = () => {
    toast.error("Erro ao buscar o status do credenciamento no Group Pay");
  };

  return useFetch({
    key: ["status-ativacao-group-pay"],
    url: api.groupPay.getStatusAtivacaoClienteGroupPay,
    onError,
    pathVariables: codigoSuporte,
    config: {
      staleTime: Infinity,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      refetchOnMount: false,
    },
  });
};
